import { ChevronLeft, ChevronRight } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';

import { Button } from 'bones/design-system/components/Button';
import {
  BUTTON_SIZE_BY_PAGINATION_SIZE,
  PAGINATION_ACTIONS_NEXT_TEST_ID,
  PAGINATION_ACTIONS_PREV_TEST_ID,
  Pagination,
  PaginationBrowse,
  PaginationProps,
  PaginationShow,
  PaginationShowProps,
} from 'bones/design-system/components/Pagination';
import { Body } from 'bones/design-system/components/typography/Body';

export type TableFooterProps = PaginationProps & {
  className?: string;
};

const TableFooterPageIndicator: React.VFC<
  Pick<TableFooterProps, 'page' | 'pages'>
> = ({ page, pages }) => (
  <div className="vb-data-table-footer-page-indicator">
    <Body size="md">Page {page}</Body>
    <Body size="md">from</Body>
    <Body size="md">{pages}</Body>
  </div>
);

export const TableFooterStyle1: React.VFC<
  TableFooterProps & PaginationShowProps
> = ({ className, onPage, page, pages, pageTestId, size }) => (
  <div className={classNames(className, 'vb-data-table-footer')}>
    <Pagination
      onPage={onPage}
      page={page}
      pages={pages}
      pageTestId={pageTestId}
      size={size}
    />
    <PaginationShow />
  </div>
);

export const TableFooterStyle2: React.VFC<TableFooterProps> = ({
  className,
  onPage,
  page,
  pages,
  pageTestId,
  size,
}) => (
  <div className={classNames(className, 'vb-data-table-footer')}>
    <Pagination
      onPage={onPage}
      page={page}
      pages={pages}
      pageTestId={pageTestId}
      size={size}
    />
    <PaginationBrowse />
  </div>
);

export const TableFooterStyle3: React.VFC<TableFooterProps> = ({
  className,
  onPage,
  page,
  pages,
  pageTestId,
  size,
}) => (
  <div className={classNames(className, 'vb-data-table-footer')}>
    <TableFooterPageIndicator page={page} pages={pages} />
    <div className="vb-data-table-footer-actions">
      <Button
        disabled={page === 1}
        onClick={() => onPage(page - 1)}
        size={BUTTON_SIZE_BY_PAGINATION_SIZE[size]}
        testId={pageTestId?.(PAGINATION_ACTIONS_PREV_TEST_ID)}
        variant="secondary-gray"
      >
        Previous
      </Button>
      <Button
        disabled={page === pages}
        onClick={() => onPage(page + 1)}
        size={BUTTON_SIZE_BY_PAGINATION_SIZE[size]}
        testId={pageTestId?.(PAGINATION_ACTIONS_NEXT_TEST_ID)}
        variant="secondary-gray"
      >
        Next
      </Button>
    </div>
  </div>
);

export const TableFooterStyle4: React.VFC<TableFooterProps> = ({
  className,
  onPage,
  page,
  pages,
  pageTestId,
  size,
}) => (
  <div className={classNames(className, 'vb-data-table-footer')}>
    <TableFooterPageIndicator page={page} pages={pages} />
    <div className="vb-data-table-footer-actions">
      <Button
        disabled={page === 1}
        leftIcon={ChevronLeft}
        onClick={() => onPage(page - 1)}
        size={BUTTON_SIZE_BY_PAGINATION_SIZE[size]}
        testId={pageTestId?.(PAGINATION_ACTIONS_PREV_TEST_ID)}
        variant="secondary-gray"
      />
      <Button
        disabled={page === pages}
        leftIcon={ChevronRight}
        onClick={() => onPage(page + 1)}
        size={BUTTON_SIZE_BY_PAGINATION_SIZE[size]}
        testId={pageTestId?.(PAGINATION_ACTIONS_NEXT_TEST_ID)}
        variant="secondary-gray"
      />
    </div>
  </div>
);
